function safeParseUrl(url: string, base?: string): URL | null {
  try {
    return new URL(url, base);
  } catch (e) {
    return null;
  }
}

export default safeParseUrl;
